import { render, staticRenderFns } from "./CompanySettings.vue?vue&type=template&id=5c21c68e&scoped=true&"
import script from "./CompanySettings.vue?vue&type=script&lang=ts&"
export * from "./CompanySettings.vue?vue&type=script&lang=ts&"
import style0 from "./CompanySettings.vue?vue&type=style&index=0&id=5c21c68e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c21c68e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCard,VContainer,VTab,VTabItem,VTabs})
